import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { isNumeric } from '../_helpers';
import ComponentRouter from './ComponentRouter';
import { styles } from '../constants';

import { View } from 'native-base';
import { Text } from 'react-native';

class BlockText extends Component {
  state = {
    visible: false
  }

  getStyle = (elementStyle) => {
    if (!elementStyle) {
      return null;
    }
    let style = {};
    let hasFontSize = false;

    Object.keys(elementStyle).forEach(e => {
      style[e] = isNumeric(elementStyle[e]) ? +elementStyle[e] : elementStyle[e];

      if (e === 'fontSize') {
        hasFontSize = true;
      }
    });

    if (hasFontSize) {
      style.fontSize = isNumeric(style.fontSize) ? style.fontSize : +style.fontSize.replace('px', '');
      style.lineHeight = style.fontSize;
    }
    return style;
  }

  handlerChange = (newValue, element) => {
    let { block, onChange, value } = this.props;

    if (element.blocks && element.blocks.length) {
      this.setState({ visible: !this.state.visible });
    }

    onChange && onChange({
      block,
      element,
      value
    });
  }

  render() {
    const { block } = this.props;
    const { visible } = this.state;

    return (
      <>
        {block.elements.map((element, i) => {

          return <View key={i}>
            <Text
              style={styles.textHeader}
              key={i}
              onPress={() => this.handlerChange(element.value, element)}
            >{element.label}</Text>
            {/* {element.blocks && element.blocks.length ? <View style={{ display:'flex'}}> */}
            {/* {element.blocks && element.blocks.length ? <View style={ visible && { display: 'block' }}> */}
            {element.blocks && element.blocks.length ? <View style={{ display: visible ? 'flex' : 'none' }}>
              {element.blocks.map((block, i) => {
                return <ComponentRouter key={i} block={block} />;
              })}
            </View> : null}

          </View>;
        })}
      </>
    );
  }
}

BlockText.propTypes = {
  block: PropTypes.object,
  onChange: PropTypes.func,
  value: PropTypes.any
};

export default BlockText;
